import React, { Component } from 'react';

import {
  Modal,
  ModalHeader,
  ModalClose,
  ModalBody,
  ModalFooter
} from 'react-modal-bootstrap';
import PropTypes from 'prop-types';
import { REASON_TYPE_NOT_CONVERTED } from '../../constants';
require('./OrderSubstitutionReasonModal.scss');

class OrderSubstitutionReasonModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReasons: [],
      reasons: [],
      loading: true,
    };
  }

  componentDidUpdate(prevProps) {
    const { getSubstitutionReasons, substitutionReasonType, show } = this.props;
    if (!prevProps.show && show) {
      getSubstitutionReasons(substitutionReasonType).then(({ data: { reasons }}) => {
        this.setState({ reasons, loading: false });
      });
    }
  }

  // componentDidMount() {
  //   const { getSubstitutionReasons, substitutionReasonType } = this.props;
  //   getSubstitutionReasons(substitutionReasonType).then(({ data: { reasons }}) => {
  //     this.setState({ reasons, loading: false });
  //   });
  // }

  handleReasonSelection = (reasonId) => {
    const { selectedReasons } = this.state;

    const currentIndex = selectedReasons.indexOf(reasonId);
    if (currentIndex > -1) {
      selectedReasons.splice(currentIndex, 1);
    } else {
      selectedReasons.push(reasonId);
    }

    return this.setState({
      selectedReasons
    });
  }

  handleSubmit = () => {
    const { selectedReasons } = this.state;
    this.props.onSubmit(selectedReasons);
    this.props.onClose();
  }

  render() {
    const {
      onClose,
      substitutionReasonType,
      show,
    } = this.props;

    const {
      selectedReasons,
      reasons,
      loading
    } =  this.state;

    const headerTitle = substitutionReasonType == REASON_TYPE_NOT_CONVERTED ?
      'Select reasons for not suggesting any Alternative' :
      'Select reasons customer went for Alternative';

    return (
      <div className="OrderSubstitutionReasonModal">
        <Modal isOpen={show} onRequestHide={onClose} backdrop={true}>
          <ModalHeader closeButton={true}>
            {headerTitle}
            <ModalClose onClick={onClose} />
          </ModalHeader>
          <ModalBody>
            <div className={ loading ? 'pe-loading' : ''}>
            {reasons.map(({id, text}) => (<label key={id} className="reasonOption">
                <input type="checkbox" onChange={() => this.handleReasonSelection(id)} value={id} defaultChecked={selectedReasons.indexOf(id) > -1} />
                <span className="reasonText">{text}</span>
              </label>))}
            </div>
          </ModalBody>
          <ModalFooter>
            {!selectedReasons.length && <span className="errorMessage">Please select atleast one reason</span>}
            <button className="submitBtn" onClick={this.handleSubmit} disabled={!selectedReasons.length}>SUBMIT</button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

OrderSubstitutionReasonModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  getSubstitutionReasons: PropTypes.func.isRequired,
  substitutionReasonType: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
};

export default OrderSubstitutionReasonModal;
